module.exports = __webpack_public_path__ + "static/media/empreenda.7e2c3021.png";